<!--
    Header nav icon, exported from Figma 4933-40092 (Hamburger).
    Kept as a `nav-` set separate from the app's older icons: these carry the
    comp's line weights (1.25 in a ~22px box, 1.0 in the 18px hamburger), which
    the previous mix did not, and swapping the shared icons would change them
    everywhere else too. `currentColor` so the header controls the colour.
-->
<template>
    <!--
        The bar-1/bar-2/bar-3 classes are load-bearing: header.vue animates them
        into an X while the slide-out is open. Figma's export has no classes, so
        they are re-applied here.
    -->
    <svg aria-hidden="true" focusable="false" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path class="bar-1 bar" d="M0.5 2L17.5 2" stroke="currentColor" stroke-linecap="round" />
        <path class="bar-2 bar" d="M0.5 9L17.5 9" stroke="currentColor" stroke-linecap="round" />
        <path class="bar-3 bar" d="M0.5 16L17.5 16" stroke="currentColor" stroke-linecap="round" />
    </svg>
</template>
